<template>
    <div>
        <div style="font-size: 15px">价格区间</div>
        <div style="margin-top: 10px">
            <van-row>
                <van-col span="11">
                    <van-field
                            style="border-radius:20px; padding: 5px 5px; box-shadow: 0px 0px 2px #333333 inset;"
                            v-model="price_min"
                            placeholder="最低价"
                            clearable
                            type="number"
                            input-align="center"
                            @input="inputMin"
                    />
                </van-col>
                <van-col span="2">
                    <div style="text-align: center; height: 32px; line-height: 32px">—</div>
                </van-col>
                <van-col span="11">
                    <van-field
                            style="border-radius:20px; padding: 5px 5px; box-shadow: 0px 0px 2px #333333 inset;"
                            v-model="price_max"
                            placeholder="最高价"
                            clearable
                            type="number"
                            input-align="center"
                            @input="inputMax"
                    />
                </van-col>
            </van-row>
            <div style="margin-top: 10px; text-align: center; display: flex; padding: 0px 10px">

                <van-checkbox v-model="smaller_checked" style="flex: auto" shape="round" checked-color="#ff0000" @click="smallerThen">
                    小于10
                </van-checkbox>
                <van-checkbox v-model="between_checked" style="flex: auto" shape="round" checked-color="#ff0000" @click="between">
                    10 - 50
                </van-checkbox>
                <van-checkbox v-model="greater_checked" style="" shape="round" checked-color="#ff0000" @click="greaterThen">
                    大于50
                </van-checkbox>
<!--                <van-row>-->
<!--                    <van-col span="8">-->
<!--                        &lt;!&ndash;                            <van-button size="small" :type="type_smaller" style="width: 90%" @click="smallerThen">小于10&ndash;&gt;-->
<!--                        &lt;!&ndash;                            </van-button>&ndash;&gt;-->
<!--                        <van-checkbox v-model="smaller_checked" shape="round" checked-color="#ff0000" @click="smallerThen">-->
<!--                            小于10-->
<!--                        </van-checkbox>-->
<!--                    </van-col>-->
<!--                    <van-col span="8">-->
<!--                        &lt;!&ndash;                            <van-button size="small" :type="type_between" style="width: 90%" @click="between">10 - 50&ndash;&gt;-->
<!--                        &lt;!&ndash;                            </van-button>&ndash;&gt;-->
<!--                        <van-checkbox v-model="between_checked" shape="round" checked-color="#ff0000" @click="between">-->
<!--                            10 - 50-->
<!--                        </van-checkbox>-->
<!--                    </van-col>-->
<!--                    <van-col span="8">-->
<!--                        &lt;!&ndash;                            <van-button size="small" :type="type_greater" style="width: 90%" @click="greaterThen">大于50&ndash;&gt;-->
<!--                        &lt;!&ndash;                            </van-button>&ndash;&gt;-->
<!--                        <van-checkbox v-model="greater_checked" shape="round" checked-color="#ff0000" @click="greaterThen">-->
<!--                            大于50-->
<!--                        </van-checkbox>-->
<!--                    </van-col>-->
<!--                </van-row>-->
            </div>
            <div style="color: orange; margin: 5px">
                *设置的筛选价格为商品原价，非券后价
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wp_limit_price_model",

        data() {
            return {
                price_min: '',
                price_max: '',

                type_smaller: 'default',
                type_between: 'default',
                type_greater: 'default',

                smaller_checked: false,
                between_checked: false,
                greater_checked: false,

            }
        },

        mounted() {

        },

        methods: {
            inputMin() {
                this.emitData(this.price_min, this.price_max);

                // this.type_smaller = 'default';
                // this.type_between = 'default';
                // this.type_greater = 'default';
                this.smaller_checked = false;
                this.between_checked = false;
                this.greater_checked = false;
            },
            inputMax() {
                this.emitData(this.price_min, this.price_max);

                // this.type_smaller = 'default';
                // this.type_between = 'default';
                // this.type_greater = 'default';
                this.smaller_checked = false;
                this.between_checked = false;
                this.greater_checked = false;
            },
            emitData(_min, _max) {
                this.$emit("getPriceLimit", {
                    price_min_str: _min,
                    price_max_str: _max
                })
            },

            // onCheckBoxChange(e){
            //     this.$log(e)
            // },

            smallerThen() {
                // if (this.type_smaller === 'warning') {
                //     this.reset();
                //
                // } else {
                //     this.type_smaller = 'warning';
                //     this.type_between = 'default';
                //     this.type_greater = 'default';
                //
                //     this.price_min = '';
                //     this.price_max = '10';
                // }

                if(this.smaller_checked){
                    this.smaller_checked = true;
                    this.between_checked = false;
                    this.greater_checked = false;

                    this.price_min = '';
                    this.price_max = '10';
                }else{
                    this.reset();
                }

                this.emitData(this.price_min, this.price_max);
            },
            between() {
                // if (this.type_between === 'warning') {
                //     this.reset();
                // } else {
                //     this.type_smaller = 'default';
                //     this.type_between = 'warning';
                //     this.type_greater = 'default';
                //
                //     this.price_min = '10';
                //     this.price_max = '50';
                // }
                if(this.between_checked){
                    this.smaller_checked = false;
                    this.between_checked = true;
                    this.greater_checked = false;

                    this.price_min = '10';
                    this.price_max = '50';
                }else{
                    this.reset();
                }

                this.emitData(this.price_min, this.price_max);
            },
            greaterThen() {
                // if (this.type_greater === 'warning') {
                //     this.reset();
                // } else {
                //     this.type_smaller = 'default';
                //     this.type_between = 'default';
                //     this.type_greater = 'warning';
                //
                //     this.price_min = '50';
                //     this.price_max = '';
                // }
                if(this.greater_checked){
                    this.smaller_checked = false;
                    this.between_checked = false;
                    this.greater_checked = true;

                    this.price_min = '50';
                    this.price_max = '';
                }else{
                    this.reset();
                }

                this.emitData(this.price_min, this.price_max);
            },

            reset() {
                this.price_min = '';
                this.price_max = '';

                // this.type_smaller = 'default';
                // this.type_between = 'default';
                // this.type_greater = 'default';
                this.smaller_checked = false;
                this.between_checked = false;
                this.greater_checked = false;
            }
        }
    }
</script>

<style scoped>

</style>